export default "__VITE_ASSET__sOsJq4I2__"